import { atom } from 'recoil';

export interface ClientDocumentsFilters {
  nameFilter?: string | null;
  startDate?: string | null;
  endDate?: string | null;
  deletedFilter?: boolean | null;
  typeFilter?: string[] | null;
  orderBy?: string | null;
  orderDirection?: 'ASC' | 'DESC' | null;
  limit?: number | null;
  offset?: number | null;
  [key: string]: string | string[] | boolean | null | number | undefined;
}

export const clientDocumentsFiltersState = atom<ClientDocumentsFilters | null>({
  key: '_clientsDocumentsFiltersState',
  default: null,
});
